import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca2137c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

import { ButtonTypesType } from '@/types/ButtonTypes';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButtonGroup',
  props: {
    buttons: { default: undefined },
    type: { default: 'colored' },
    btnWidth: { default: undefined },
    btnHeight: { default: '28' },
    active: { default: undefined },
    textKey: { default: 'text' },
    isLoading: { type: Boolean }
  },
  emits: ['changeActiveBtn'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const changeActiveBtn = <T,>(i: T) => {
  emit('changeActiveBtn', i);
};

const cssProps = computed(() => {
  return {
    '--btn-width': props.btnWidth + 'px',
  };
});

return (_ctx: any,_cache: any) => {
  const _component_base_skeleton_loader = _resolveComponent("base-skeleton-loader")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle([cssProps.value]),
        class: "button-group"
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
          return _createElementVNode("div", { key: i }, [
            _createVNode(_component_base_skeleton_loader, {
              style: _normalizeStyle({ height: _ctx.btnHeight + 'px', width: _ctx.btnWidth + 'px' }),
              type: "btn"
            }, null, 8, ["style"])
          ])
        }), 64))
      ], 4))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        style: _normalizeStyle([cssProps.value]),
        class: "button-group"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons, (btn, i) => {
          return (_openBlock(), _createElementBlock("div", { key: i }, [
            _createVNode(_component_base_button, {
              active: _ctx.active === btn.id,
              height: _ctx.btnHeight,
              "style-type": _ctx.type,
              allBlockWidth: "",
              onClick: ($event: any) => (changeActiveBtn(btn))
            }, {
              text: _withCtx(() => [
                _renderSlot(_ctx.$slots, "btnText", { data: btn }),
                (!_ctx.$slots.btnText)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(btn[_ctx.textKey]), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["active", "height", "style-type", "onClick"])
          ]))
        }), 128))
      ], 4))
}
}

})